import Sources from '../components/pages/Sources/Sources.vue'
import SourceTable from '../components/pages/Sources/SourcesTable/SourcesTable.vue'

const SourcesTableHead = () => import('../components/pages/Sources/SourcesTableHead')

export default [
  {
    path: '/sources',
    component: Sources,
    children: [
      {
        name: 'sources',
        path: '',
        components: {
          default: SourceTable,
          tableHead: SourcesTableHead
        }
      }
    ]
  }
]
